var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhiteSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00861 2.71929C5.99054 0.965704 8.77738 0 11.8574 0C14.8731 0 17.7795 1.11151 19.8314 3.04883L20.0017 3.20892L20.1717 3.04883C22.2236 1.11151 25.1297 0 28.1452 0C31.2247 0 34.0121 0.965704 35.994 2.71929C37.8921 4.3985 39.0684 6.14248 39.0684 9.64128L39.0676 29.9765H33.5113L33.5103 9.64128C33.5103 6.96706 31.1542 4.87211 28.1449 4.87211C25.1367 4.87211 22.7796 6.96681 22.7796 9.64128L22.7791 29.9765H17.2223L17.2213 9.64128C17.2213 6.96706 14.8652 4.87211 11.8567 4.87211C8.8479 4.87211 6.4911 6.96681 6.4911 9.64128L6.49011 29.9765H0.934498L0.932766 9.64128C0.93425 6.14248 2.11055 4.3985 4.00861 2.71929Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteSmall);
export default __webpack_public_path__ + "static/media/logo-white-small.e0837601b68db698d446007022a681ed.svg";
export { ForwardRef as ReactComponent };